<script>
export default {
    data() {
        return {
            emailDebounceTimer: null,
            idDebounceTimer: null,
            localFilters: {
                id: null,
                email: '',
                is_active: 'all',
                user_role_id: 'all',
                subscription_plan_id: 'all',
            },
        };
    },
    computed: {
        filters() {
            return this.$store.getters.USER_SEARCH;
        },
        roles() {
            return this.$store.getters.ROLES;
        },
        subscriptionPlans() {
            return this.$store.getters.SUBSCRIPTION_PLANS;
        },
        isPlansLoaded() {
            return this.$store.getters.IS_PLANS_LOADED;
        },
        activeFilterCount() {
            let count = 0;
            if (this.localFilters.id) count++;
            if (this.localFilters.email) count++;
            if (this.localFilters.is_active !== 'all') count++;
            if (this.localFilters.user_role_id !== 'all') count++;
            if (this.localFilters.subscription_plan_id !== 'all') count++;
            return count;
        },
    },
    mounted() {
        // Initialize from store
        this.localFilters = { ...this.filters };

        // Load subscription plans if not loaded
        if (!this.isPlansLoaded) {
            this.$store.dispatch('loadSubscriptionPlans');
        }
    },
    methods: {
        handleIdInput() {
            // Debounce ID filter (300ms)
            clearTimeout(this.idDebounceTimer);
            this.idDebounceTimer = setTimeout(() => {
                this.applyFilters();
            }, 300);
        },

        handleEmailInput() {
            // Debounce email filter (300ms)
            clearTimeout(this.emailDebounceTimer);
            this.emailDebounceTimer = setTimeout(() => {
                this.applyFilters();
            }, 300);
        },

        applyFilters() {
            // Update store with new filters
            this.$store.commit('USER_SEARCH', this.localFilters);
            this.$store.commit('SET_USER_OFFSET', 0); // Reset to first page
            this.$store.dispatch('loadUsers');
        },

        clearFilters() {
            this.localFilters = {
                id: null,
                email: '',
                is_active: 'all',
                user_role_id: 'all',
                subscription_plan_id: 'all',
            };
            this.$store.commit('RESET_USER_FILTERS');
            this.$store.dispatch('loadUsers');
        },
    },
};
</script>

<template>
    <div class="filters_container">
        <div class="filters_header">
            <label class="filter_title">Filters</label>
            <button
                v-if="activeFilterCount > 0"
                @click="clearFilters"
                class="clear_button"
            >
                Clear All ({{ activeFilterCount }})
            </button>
        </div>

        <div class="filters_grid">
            <div class="filter_field">
                <label class="mb_5">User ID:</label>
                <input
                    v-model.number="localFilters.id"
                    type="number"
                    placeholder="e.g., 123"
                    @input="handleIdInput"
                />
            </div>

            <div class="filter_field">
                <label class="mb_5">Email:</label>
                <input
                    v-model="localFilters.email"
                    type="text"
                    placeholder="Search by email..."
                    @input="handleEmailInput"
                />
            </div>

            <div class="filter_field">
                <label class="mb_5">Status:</label>
                <select v-model="localFilters.is_active" @change="applyFilters">
                    <option value="all">All Users</option>
                    <option :value="true">Active Only</option>
                    <option :value="false">Inactive Only</option>
                </select>
            </div>

            <div class="filter_field">
                <label class="mb_5">Role:</label>
                <select
                    v-model="localFilters.user_role_id"
                    @change="applyFilters"
                >
                    <option value="all">All Roles</option>
                    <option
                        v-for="role in roles"
                        :key="role.id"
                        :value="role.id"
                    >
                        {{ role.name }}
                    </option>
                </select>
            </div>

            <div class="filter_field">
                <label class="mb_5">Subscription Plan:</label>
                <select
                    v-model="localFilters.subscription_plan_id"
                    @change="applyFilters"
                >
                    <option value="all">All Plans</option>
                    <option
                        v-for="plan in subscriptionPlans"
                        :key="plan.id"
                        :value="plan.id"
                    >
                        {{ plan.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<style scoped>
.filters_container {
    background: var(--background-color);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
}

.filters_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.filter_title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-color);
}

.clear_button {
    background: transparent;
    border: 1px solid var(--border-color);
    color: var(--text-color);
    padding: 5px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease;
}

.clear_button:hover {
    background: var(--background-hover);
    border-color: var(--primary-color);
}

.filters_grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
}

.filter_field {
    display: flex;
    flex-direction: column;
}

.filter_field label {
    font-size: 14px;
    color: var(--text-color);
    margin-bottom: 5px;
}

.filter_field input,
.filter_field select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: var(--background-color);
    color: var(--text-color);
    font-size: 14px;
}

.filter_field input:focus,
.filter_field select:focus {
    outline: none;
    border-color: var(--primary-color);
}
</style>
